// export default async (context, locale) => {
//   console.log('en-US', context, locale)
//   await Promise.resolve({
//     welcome: '欢迎光临',
//     chakangengduo: '查看更多'
//   })
// }
// components
import tagFilter from '@/locales/en-US/component/tag-filter'
// layout
import topHeader from '@/locales/en-US/layout/topHeader'
import header from '@/locales/en-US/layout/header'
import footer from '@/locales/en-US/layout/footer'
import layoutDefault from '@/locales/en-US/layout/layoutDefault'
// system
import api from '@/locales/en-US/system/api'
import basic from '@/locales/en-US/system/basic'
import formTip from '@/locales/en-US/system/formTip'
import tip from '@/locales/en-US/system/tip'
import statistics from '@/locales/en-US/system/statistics'
// business
import home from '@/locales/en-US/business/home'
import bidding from '@/locales/en-US/business/bidding'
import company from '@/locales/en-US/business/company'
import exhibitor from '@/locales/en-US/business/exhibitor'
import live from '@/locales/en-US/business/live'
import meeting from '@/locales/en-US/business/meeting'
import modal from '@/locales/en-US/business/modal'
import member from '@/locales/en-US/business/member'
import news from '@/locales/en-US/business/news'
import product from '@/locales/en-US/business/product'
import poster from '@/locales/en-US/business/poster'
import threed from '@/locales/en-US/business/threed'
import all from '@/locales/en-US/business/all'
import vip from '@/locales/en-US/business/vip'
import merchants from '@/locales/en-US/business/merchants'
import enterpriseCertification from '@/locales/en-US/business/enterpriseCertification'
import enterpriseSettledCenter from '@/locales/en-US/business/enterpriseSettledCenter'
import purchase from '@/locales/en-US/business/purchase'
import invite from '@/locales/en-US/business/invite'
import szls from '@/locales/en-US/business/szls'
import smsInvite from '@/locales/en-US/business/smsInvite'
import myHome from '@/locales/en-US/business/myHome'
import companyHome from '@/locales/en-US/business/companyHome'

// customized
import customizedCloudexhibition from '@/locales/en-US/customized/cloudexhibition'
/** 会员中心引入 */
// business
import tempcompany from '@/locales/member-center/en-US/business/company'
import tempexhibitor from '@/locales/member-center/en-US/business/exhibitor'
import tempmember from '@/locales/member-center/en-US/business/member'
import tempproduct from '@/locales/member-center/en-US/business/product'
import tempnamecard from '@/locales/member-center/en-US/business/namecard'
import tempsms from '@/locales/member-center/en-US/business/sms'
import tempaddressBook from '@/locales/member-center/en-US/business/addressBook'
import tempcloudData from '@/locales/member-center/en-US/business/cloudData'
import tempcoupon from '@/locales/member-center/en-US/business/coupon'
// system
import tempbasic from '@/locales/member-center/en-US/system/basic'
import tempmenu from '@/locales/member-center/en-US/system/menu'
import tempform from '@/locales/member-center/en-US/system/form'
import cloudData from '~/locales/en-US/business/cloudData'
import Supply from '~/locales/en-US/business/supply'

export default {
  // temp memberCenter
  ...tempcompany,
  ...tempexhibitor,
  ...tempmember,
  ...tempproduct,
  ...tempnamecard,
  ...tempbasic,
  ...tempmenu,
  ...tempform,
  ...tempsms,
  ...tempaddressBook,
  ...tempcloudData,
  ...tempcoupon,
  // components
  ...tagFilter,
  // layout
  ...topHeader,
  ...header,
  ...footer,
  ...layoutDefault,
  // system
  ...api,
  ...basic,
  ...formTip,
  ...tip,
  ...statistics,
  // business
  ...home,
  ...bidding,
  ...company,
  ...exhibitor,
  ...live,
  ...meeting,
  ...modal,
  ...member,
  ...news,
  ...product,
  ...poster,
  ...threed,
  ...all,
  ...vip,
  ...merchants,
  ...enterpriseCertification,
  ...enterpriseSettledCenter,
  ...purchase,
  ...invite,
  ...szls,
  ...cloudData,
  // customized
  ...customizedCloudexhibition,
  ...smsInvite,
  ...myHome,
  ...companyHome,
  ...Supply,
}
